<template>
    <div class="base-statistics">
        <div class="first-column">
            <div class="statistics-value" :class="{[`text-${variant}`]: variant}">
                {{value}}
            </div>
            <div class="statistics-text">{{text}}</div>
        </div>
        <slot>
            <base-icon v-if="icon" :icon="icon" class="statistics-icon" :class="{[`text-${variant}`]: variant}"/>
        </slot>
    </div>
</template>

<script>
    export default {
        name: "BaseStatistics",
        props: {
            icon: {
                type: [String, Array],
                default: null
            },
            text: {
                type: String,
                required: true
            },
            value: {
                type: [Number, Boolean, String],
                required: true
            },
            variant: {
                type: String,
                default: "dark"
            }
        },
    };
</script>

<style scoped lang="scss">
    @import "~@/assets/scss/variables";

    .base-statistics {
        display: flex;
        align-items: center;
        padding: #{$spacer/2} $spacer;
        background-color: $gray-100;
        border: thin solid $gray-200;

        &:not(:last-child) {
            border-bottom: none;
        }

        .first-column {
            flex: 1 1 auto;
            display: flex;
            flex-direction: column;
        }

        .statistics-value {
            font-size: 2rem;
            font-weight: bold;
        }

        .statistics-text {
            text-transform: uppercase;
            font-weight: 300;
        }

        .statistics-icon {
            flex: 0 0 auto;
            font-size: 2rem;
            width: 3rem;
            height: 3rem;
        }
    }
</style>